<script setup lang="ts">
import { useAutoBreadcrumbs } from "~/composables/useAutoBreadCrumbs"
import { MAIN_ROUTE } from "~/common/crumbs_menu"


/**
 *
 *  Props and emits section
 *
 *
*/

/**
 *
 *  Ref, computed and hooks section
 *
 *
*/

const route = useRoute()
const router = useRouter()

const { breadCrumbs } = useAutoBreadcrumbs()

/**
 *
 *  Life cicle events
 *
 *
*/

/**
 *
 *  Functions section
 *
 *
*/

</script>

<template>
    <q-breadcrumbs
        align="left"
        class="tw-ml-5 tw-text-adminAccent-200"
        v-show="route.name != MAIN_ROUTE"
    >
        <template v-for="crumb in breadCrumbs">
            <q-breadcrumbs-el
                :icon="crumb.icon"
                @click="() => crumb.to && router.push(crumb.to)"
                :label="crumb.labelKey"
                class="tw-cursor-pointer tw-text-adminAccent-200"
            />
        </template>
    </q-breadcrumbs>
</template>